import { useParams, NavLink } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../utils/getLocatPath/getLocalPath';
import { getRandomRangeArray } from '../../../utils/getRandomRangeArray/getRandomRangeArray';
import styles from '../Home.module.scss';
import { useTransition } from 'react';

export const World = ({ upPage }) => {
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const { world } = upPage.acf;
  const { subtitle, title, text, content } = world;
  const upRanArr = getRandomRangeArray(4, 8, content.length);

  return (
    <section className={styles.world}>
      <div className="container">
        <div className={styles.world_body}>
          <h3 className={`${styles.world_subtitle} global-subtitle`}>{subtitle[lang]}</h3>
          <h2 className={`${styles.world_title} global-title`}>{title[lang]}</h2>
          <p className={styles.world_text}>{text[lang]}</p>
          <div className={styles.world_row}>
            {content.map((el, idx) => {
              const { gradient, icon, subtitle, title } = el;
              return (
                <div key={idx} className={styles.world_column}>
                  <NavLink className={styles.world_column_body}>
                    <div className={styles.world_column_gradient} style={{ background: gradient, backgroundSize: '400% 400%' }}></div>
                    <div
                      className={styles.world_column_icon}
                      style={{
                        animation: `${styles.bounce_world} ${upRanArr[idx]}s ease-in-out infinite`,
                      }}
                    >
                      {icon}
                    </div>
                    <div className={styles.world_column_null}></div>
                    <div className={styles.world_column_content}>
                      <h4 className={styles.world_column_subtitle}>{subtitle[lang]}</h4>
                      <h3 className={styles.world_column_title}>{title[lang]}</h3>
                      <div className={styles.world_column_link}>
                        {t('Қараңыз', 'Смотреть', lang)}
                        <span>→</span>
                      </div>
                    </div>
                  </NavLink>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
